module.exports = __webpack_public_path__ + "img/ico-visual-platform_2.76d6e4b6.svg";